// var md = new MobileDetect(window.navigator.userAgent);

var $ = jQuery.noConflict();


$(document).ready(function () {

	$('.module-fleet__selector__item button').click(function () {
		window.location.hash = $(this).data('tab');
	});


	var hash = window.location.hash;

	var prefix = "#";
	if (hash) {
		setTimeout(function () {
			$('.module-fleet__selector__item button[data-tab="' + hash.replace(prefix, "") + '"]').click();
		}, 500);
	}

	$('.fleet-menu-item').click(function () {
		var href = $(this).find('a').attr('href');
		var hash = href.substring(href.indexOf('#') + 1);
		$('.module-fleet__selector__item button[data-tab="' + hash + '"]').click();
	});

	var menuOpen = false;
	var menuOpener = $('.menu-open');
	var menuFull = $('.topheader__nav');
	var menuTopNav = $('.topheader__navbar');
	var menuMainBar = $('.topheader__main');
	var menuOverBox = $('.topheader__overbox');
	var menuOverBoxColor = $('.topheader__overboxColor');
	var menuLangSelector = $('.language-selector');

	menuOpener.click(function (e) {
		e.preventDefault();
		var self = $(this);
		if (menuOpen) {
			menuOpener.removeClass('is-active');
			menuFull.removeClass('is-open');
			//menuTopNav.removeClass('is-hidden');
			menuLangSelector.addClass('is-hidden');
			menuMainBar.removeClass('is-filed');
			menuOverBoxColor.removeClass('is-visible');
			$('body').removeClass('mobile-menu-open');
			$('body').css('padding-right', 0);
			menuMainBar.css('width', '100%');
			menuFull.css('width', '100%');
			menuOverBox.hide();
			menuOpen = false;

		} else {
			menuOpener.addClass('is-active');
			menuFull.addClass('is-open');
			//menuTopNav.addClass('is-hidden');
			menuLangSelector.removeClass('is-hidden');
			menuMainBar.addClass('is-filed');
			menuOverBoxColor.addClass('is-visible');
			menuOverBox.show();
			menuOpen = true;
			$('#mobile-nav').show();
			setTimeout(function () {
				$('#mobile-nav').addClass('active');
				baseWindow = $(window).innerWidth();
				$('body').addClass('mobile-menu-open');
				scrollWidth = $(window).innerWidth() - baseWindow;
				$('body').css('padding-right', scrollWidth);
				menuMainBar.css('width', 'calc(100% - ' + scrollWidth + 'px)');
				menuFull.css('width', 'calc(100% - ' + scrollWidth + 'px)');
			}, 1);
		}
	});
	$('.menu-close').click(function (e) {
		e.preventDefault();
		$('#mobile-nav').removeClass('active');
		setTimeout(function () {
			$('body').removeClass('mobile-menu-open');
			$('body').css('padding-right', 0);
			$('header').css('width', '100%');
			$('#mobile-nav').hide();
		}, 300);
	});

	var fromtop = 50;

	function headerScrollSize() {
		if ($(window).scrollTop() >= fromtop) {
			$('.topheader__main').addClass('slim');
			$('.topheader__nav').addClass('slim');

		} else {
			$('.topheader__main').removeClass('slim');
			$('.topheader__nav').removeClass('slim');
		}
	}

	$(window).scroll(function () {
		headerScrollSize();
	});
	headerScrollSize();

	$('.dropdown-open').click(function () {
		$(this).toggleClass('is-active');
		$(this).closest('.topheader__nav__list__item--dropdown').find('ul').toggleClass('is-active');
	})

	var currentTab = 1;
	$('.module-fleet__selector__item__button').click(function () {
		var target = $(this).attr('data-tab');
		if (target != currentTab) {
			currentTab = target;
			$('.module-fleet__selector__item__button').removeClass('is-active');
			$(this).addClass('is-active');

			$('.module-fleet__tabs__tab').hide();
			$('.module-fleet__tabs__tab[data-tab="' + target + '"]').fadeIn();
		}
	});

	$('.module-callbar__form').submit(function (e) {
		e.preventDefault();
		$('.module-callbar__form__respond__spinner').show();
		$('.module-callbar__form__respond').addClass('is-visible');
		setTimeout(function () {
			$('.module-callbar__form__respond__spinner').hide();
			$('.module-callbar__form__respond__text--positive').show();
		}, 1500);
	});
	$('.module-callbar__form__respond').click(function (e) {
		e.stopPropagation();
		$('.module-callbar__form__respond').removeClass('is-visible');
		setTimeout(function () {
			$('.module-callbar__form__respond__text').hide();
		}, 500);
	});


	var mySwiper = new Swiper('.swiper-normal', {
		// Optional parameters
		direction: 'horizontal',
		loop: true,
		speed: 1800,
		autoplay: {
			delay: 4000,
		},
		effect: 'fade',
		// If we need pagination
		pagination: {
			el: '.swiper-pagination',
			clickable: true
		},
		// Navigation arrows


	});
	new Swiper('.swiper-container--gallery', {
		// Optional parameters
		direction: 'horizontal',
		loop: true,
		speed: 500,
		autoplay: {
			disableOnInteraction: false,
			delay: 3000,
		},
		slidesPerView: 1,
		breakpointsInverse: true,
		breakpoints: {
			960: {

				slidesPerView: 2,
			},
			1100: {

				slidesPerView: 4,
			}

		}
		// Navigation arrows


	});


});
var phoneMask = ['+', '4', '8', ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/]

// Assuming you have an input element in your HTML with the class .myInput
var myInput = document.querySelector('.module-callbar__input')

var maskedInputController = vanillaTextMask.maskInput({
	inputElement: myInput,
	mask: phoneMask
})
